const useCampaign = (campaign_type, bundles_product_id = null, getFullCampaign = false) => (campaigns, cart_items) => {
	const noCampaign = new Array(2).fill(null);
	if (!campaigns) return noCampaign;

	let product_campaign = noCampaign;

	const global_campaigns = Object.values(campaigns)
		.flat(Infinity)
		.filter((campaign) => campaign.isGlobal);
	if (campaign_type === 'bundles') {
		const product_campaigns = campaigns[bundles_product_id] || [];
		const bundles_campaign =
			product_campaigns.find(({ type }) => type === 'bundles') ||
			global_campaigns.find(({ type }) => type === 'bundles');
		if (bundles_campaign) product_campaign = [bundles_product_id, bundles_campaign];
	} else {
		// add to unlock and one tick renders a single campaign at time
		const itemsIds = [...cart_items].reverse().map(({ product_id }) => product_id.toString());
		const type_campaign = Object.entries(campaigns)
			.sort(([a], [b]) => {
				const AIndex = itemsIds.indexOf(a) === -1 ? itemsIds.length + 1 : itemsIds.indexOf(a);
				const BIndex = itemsIds.indexOf(b) === -1 ? itemsIds.length + 1 : itemsIds.indexOf(b);
				return AIndex - BIndex;
			})
			.find(([product_id, product_campaigns]) => {
				const productGlobalCampaigns = product_campaigns.filter((campaign) => campaign.isGlobal)
				const productIsAddedToCart = cart_items.map(({ product_id: id }) => id).includes(parseInt(product_id))
				if (!productGlobalCampaigns.length && !productIsAddedToCart) return false;
				return productIsAddedToCart ? product_campaigns.find(({ type }) => type === campaign_type) : productGlobalCampaigns.find(({ type }) => type === campaign_type);
			});
		if (type_campaign) {
			const [id, camps] = type_campaign;
			product_campaign = [id, camps.find(({ type }) => type === campaign_type)];
		}
	}

	const [product_id, campaign] = product_campaign;
	return product_id ? [product_id, getFullCampaign ? campaign : campaign[campaign_type], campaign.isGlobal] : noCampaign;
};

const getCampaignsByType = (campaign_type) => (campaigns) =>
	Object.values(campaigns)
		.filter(({ type }) => type === campaign_type)
		.map((campaign) => campaign[campaign_type]);
export default useCampaign;
